<div class="dynamic-field form-input" [class.last-err]="config.name === 'confirmPassword'" [formGroup]="group">
  <rx-icon [name]="config.icon" size="12"></rx-icon>
  <input
    [formControlName]="config.name"
    [type]="isPasswordHidden ? config.type : 'text'"
    [placeholder]="config.placeholder"
  />
  <button
    type="button"
    class="visibility filled-label-text-size"
    (click)="togglePasswordVisibility()"
    mat-icon-button
    matSuffix
  >
    <mat-icon>
      {{ isPasswordHidden ? 'visibility_off' : 'visibility' }}
    </mat-icon>
  </button>
</div>
<mat-error *ngIf="passwordMismatches">Not Matching</mat-error>
